module.exports = __webpack_public_path__ + "static/media/kun-9.jpeg";